const Contact = () =>{
    return (
        <div>
            <h1>Contact ME!!</h1>
            <p>sjdsbs</p>
        </div>
    )
}

export default Contact